// extracted by mini-css-extract-plugin
export var active = "_eh-7";
export var blink = "_eh-8";
export var dropDownSelector = "_eh-4";
export var dropDownWrapper = "_eh-3";
export var fakeCursor = "_eh-6";
export var fontSizeButton = "_eh-9";
export var formQuillEditor = "_eh-0";
export var pressed = "_eh-a";
export var qlBlank = "_eh-1";
export var textFormattingToolbar = "_eh-2";
export var textToolbarOption = "_eh-5";